<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Cabang</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA UMUM</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kode Cabang</b-col>
                    <b-col>{{ cabang.kode }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama Cabang</b-col>
                    <b-col>{{ cabang.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kelas Cabang</b-col>
                    <b-col>Kelas {{ cabang.branchClass }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status Cabang</b-col>
                    <b-col>
                        <strong v-if="cabang.isActive != null">{{ (cabang.isActive == true) ?"Buka" : "Tutup" }} {{ (cabang.closedAt != null && cabang.isActive == false) ? "( " + $helper.changeDateFormat(cabang.closedAt) +" )"  :"" }}</strong>
                        <strong v-else>-</strong>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Alamat Cabang</b-col>
                    <b-col>{{ cabang.alamat }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kota Cabang</b-col>
                    <b-col>{{ cabang.kota.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama di Banner</b-col>
                    <b-col>{{ cabang.bannerName || '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Telp Cabang</b-col>
                    <b-col v-if="cabang.noTelp != null">{{ cabang.noTelp }}</b-col>
					<b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Cabang</b-col>
                    <b-col>{{ getJenisCabangLabel(cabang) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Cash in Hand</b-col>
                    <b-col>
                        <strong v-if="cabang.cashInHand == null">{{$helper.addThousandSeparator(cabang.cashInHand)}} </strong>
                        <strong v-else-if="cabang.cashInHand < 0">- Rp{{$helper.addThousandSeparator(cabang.cashInHand).replace("-", "")}}</strong>
                        <strong v-else>Rp. {{$helper.addThousandSeparator(cabang.cashInHand)}} </strong>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kas Virtual</b-col>
                    <b-col>
                        <strong v-if="cabang.cashVirtual == null">{{$helper.addThousandSeparator(cabang.cashVirtual)}} </strong>
                        <strong v-else-if="cabang.cashVirtual < 0">- Rp{{$helper.addThousandSeparator(cabang.cashVirtual).replace("-", "")}}</strong>
                        <strong v-else>Rp. {{$helper.addThousandSeparator(cabang.cashVirtual)}} </strong>
                    </b-col>
                </b-row>
                <!-- <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Skema Perhitungan</b-col>
                    <b-col>{{ cabang.skema.name }}</b-col>
                </b-row> -->
				<b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Latitude</b-col>
                    <b-col v-if="cabang.latitude != null">{{ cabang.latitude }}</b-col>
					<b-col v-else>-</b-col>
                </b-row>
				<b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Longitude</b-col>
                    <b-col v-if="cabang.longitude != null">{{ cabang.longitude }}</b-col>
					<b-col v-else>-</b-col>
                </b-row>
				<b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Alamat IP Cabang</b-col>
                    <b-col v-if="cabang.ipAddress != null">{{ cabang.ipAddress }}</b-col>
					<b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal Operasional</b-col>
                    <b-col v-if="cabang.operationalDate != null">{{ $helper.changeDateFormat(cabang.operationalDate) }}</b-col>
					<b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status Kas Virtual</b-col>
                    <b-col>
                        <strong>{{ cabang.dokuStatus == STATUS_KAS_VIRTUAL.ACTIVE ? "Aktif" :"Non-Aktif" }}</strong>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Gadai Emas</b-col>
                    <b-col>
                        <strong v-if="cabang.gadaiEmasActive != null">{{ (cabang.gadaiEmasActive == true) ?"Aktif" :"Non-Aktif"}}</strong>
                        <strong v-else>-</strong>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Biaya Asuransi</b-col>
                    <b-col>
                        <strong v-if="cabang.isUsingAdminFee != null">{{ (cabang.isUsingAdminFee == true) ?"Aktif" :"Non-Aktif"}}</strong>
                        <strong v-else>-</strong>
                    </b-col>
                </b-row>
             
            </div>
            <div class="detail-data-wrapper">
                <h6 class="form-title">DATA STAFF</h6>
                <b-row class="mb-4">
                    <b-col cols="4" v-if="cabang.ku != null">
                        <div class="card-wrapper">
                            <div class="card-people-head" align="center">KEPALA UNIT</div>
                            <h6 class="mb-1">{{ cabang.ku.fullname }}</h6>
                            <div class="small-text text-muted">{{ cabang.ku.noHp || "-" }}</div>
                            <div class="small-text text-muted">{{ cabang.ku.email || "-" }}</div>
                        </div>
                    </b-col>
                    <b-col cols="4" v-if="cabang.kc != null">
                        <div class="card-wrapper">
                            <div class="card-people-head" align="center">KEPALA CABANG</div>
                            <h6 class="mb-1">{{ cabang.kc.fullname }}</h6>
                            <div class="small-text text-muted">{{ cabang.kc.noHp || "-" }}</div>
                            <div class="small-text text-muted">{{ cabang.kc.email || "-" }}</div>
                        </div>
                    </b-col>
                    <b-col cols="4" v-if="cabang.kcs != null">
                        <div class="card-wrapper">
                            <div class="card-people-head" align="center">AREA MANAGER</div>
                            <h6 class="mb-1">{{ cabang.kcs.fullname }}</h6>
                            <div class="small-text text-muted">{{ cabang.kcs.noHp || "-" }}</div>
                            <div class="small-text text-muted">{{ cabang.kcs.email || "-" }}</div>
						</div>
                    </b-col>
                </b-row>
                <b-table bordered hover show-empty
                    :busy="isBusy" 
                    :items="cabang.staffs" 
                    :fields="fields"
                    :currentPage="currentPage" 
                    :perPage="perPage"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data staff.
                    </template>
                    <template v-slot:cell(role)="row">
                        {{row.item.role.level}} - {{row.item.role.name}}
                    </template>
                </b-table>
                <div class="d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
            <div class="detail-data-wrapper">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <h6 class="form-title mb-0">METODE PENGIRIMAN</h6>
                    <b-button variant="pgiBtn" size="sm" name="tambahMetodeKirimBtn" :disabled="isLoadingDeliveryChannelOptions" @click="openModalMetodeKirim()">
                        <b-spinner small v-if="isLoadingDeliveryChannelOptions" />
                        <span v-else>Tambah Pengiriman</span>
                    </b-button>
                </div>
                <b-table bordered hover show-empty :items="deliveryChannels" :fields="deliveryFields" responsive class="mb-0">
                    <template v-slot:empty>
                        Belum ada metode pengiriman.
                    </template>
                    <template v-slot:cell(jenisPinjaman)="row">
                        {{ (jenisPinjamanOptions.find(item => item.id == row.item.jenisPinjamanId) || {}).name || '-' }}
                    </template>
                    <template v-slot:cell(dropOffDestinationCabangName)="row">
                        {{ row.item.isDropOffToOwnCabang ? 'Cabang Sendiri' : (row.item.dropOffDestinationCabangName || '-') }}
                    </template>
                    <template v-slot:cell(aksi)="row">
                        <b-button variant="pgiBtn" size="sm" :name="`editMetodeKirimBtn-${row.item.id}`" :disabled="isLoadingDeliveryChannelOptions" @click="openModalMetodeKirim(row.item)">
                            Edit
                        </b-button>
                    </template>
                </b-table>
            </div>
            <div class="d-flex justify-content-between  detail-edit-btn">
                <b-button variant="pgiBtn" name="cabangEditBtn" @click="editCabang">Edit</b-button>
                <b-button v-if="menu.includes('MIC')" variant="danger" class="btn btn-secondary" name="cabangEditBtn" @click="modalMutasi">Mutasi Kas dan Inventaris</b-button>
            </div>
        </b-card>
        <b-modal id="modal-tambah-metode-kirim" :title="editingMetodeKirimId ? 'Edit Metode Pengiriman' : 'Tambah Metode Pengiriman'" centered hide-footer>
            <b-form-group label="Jenis Pinjaman">
                <b-form-select v-model="newMetodeKirim.jenisPinjamanId" :options="jenisPinjamanOptions" value-field="id" text-field="name" name="jenisPinjamanPicker" :disabled="editingMetodeKirimId != null">
                    <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- Pilih jenis pinjaman --</b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>
            <b-form-group label="Metode Pengiriman">
                <multiselect
                    class="ml-0"
                    name="metodeKirimPicker"
                    v-model="newMetodeKirim.deliveryChannel"
                    :options="deliveryChannelOptions"
                    :allow-empty="false"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="-- Pilih metode pengiriman --"
                />
            </b-form-group>
            <b-form-group label="Titik Drop Off" description="Kosongkan jika drop off di cabang sendiri.">
                <multiselect
                    class="ml-0"
                    name="dropOffCabangPicker"
                    v-model="newMetodeKirim.dropOffCabang"
                    :options="cabangOption"
                    :allow-empty="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Cabang Sendiri"
                />
            </b-form-group>
            <b-form-group label="Tujuan SM">
                <multiselect
                    class="ml-0"
                    name="smDestinationPicker"
                    v-model="newMetodeKirim.smDestination"
                    :options="smDestinationOptions"
                    :allow-empty="false"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="-- Pilih tujuan SM --"
                />
            </b-form-group>
            <div class="text-right">
                <b-button variant="pgiBtn" name="simpanMetodeKirimBtn" :disabled="!canSubmitMetodeKirim || isSubmittingMetodeKirim" @click="submitMetodeKirim">
                    <b-spinner small v-if="isSubmittingMetodeKirim" />
                    <span v-else>Simpan</span>
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-mutasi" size="md" title="Pilih tujuan mutasi">
            <p>Seluruh gadai dengan status BERJALAN pada cabang ini, akan dipindahkan ke cabang tujuan. Seluruh Cash in Hand akan dimutasikan juga ke cabang tujuan.</p>
            <b-form-group >
                <div>
                    <multiselect
                    class="ml-0"
                    name="filterCabang"
                    v-model="input.cabang" 
                    :options="cabangOption" 
                    :internal-search="true"
                    :allow-empty="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="name"
                    placeholder="-- Pilih cabang Tujuan --"
                    />
                </div>
            </b-form-group>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                    Close
                </b-button>
                <b-button variant="primary" name="closePreviewBtn" @click="confirmMutasi()">
                    Submit
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-confirm-mutasi" title="Konfirmasi" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Konfirmasi mutasi cabang <strong>{{ (cabang != null) ? cabang.name : "" }}</strong> ke  <strong>{{ (input.cabang != null) ? input.cabang.name : "" }}</strong> ?
                <div class="mt-4 text-right">
                    <b-button variant="pgiBtn" :disabled="isSubmitting" @click="submitMutasi">
                        {{ isSubmitting ? "Loading..." : "Ya" }}
                    </b-button>
                </div> 
        </b-modal>
    </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
    name: 'detail-cabang',
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10,
                cabang: null
            },
            isSubmitting: false,
            fields: [
                { key: "fullname", label: "Nama Staff", sortable:true},
                { key: "role", label: "Level - Role" },
                { key: "noHp", label: "No. Hp Staff", sortable:true},
                { key: "email", label: "Email Staff", sortable:true},
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            cabang: {
                ku: null,
                kc: null,
                kcs: null
            },
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',

            menu:localStorage.getItem('menuChildren'),
            cabangOption: [],

            deliveryFields: [
                { key: "jenisPinjaman", label: "Jenis Pinjaman" },
                { key: "deliveryChannelName", label: "Metode Pengiriman" },
                { key: "dropOffDestinationCabangName", label: "Titik Drop Off" },
                { key: "smDestinationName", label: "Tujuan SM" },
                { key: "aksi", label: "Aksi" },
            ],
            deliveryChannels: [],
            deliveryChannelOptions: [],
            smDestinationOptions: [],
            jenisPinjamanOptions: [
                { id: CONSTANTS.GADAI.JENIS.ELEKTRONIK, name: 'Elektronik' },
                { id: CONSTANTS.GADAI.JENIS.EMAS, name: 'Emas' },
            ],
            newMetodeKirim: {
                jenisPinjamanId: null,
                deliveryChannel: null,
                dropOffCabang: null,
                smDestination: null,
            },
            isLoadingDeliveryChannelOptions: false,
            isSubmittingMetodeKirim: false,
            editingMetodeKirimId: null
        }
    },

    computed: {
        STATUS_KAS_VIRTUAL() {
            return CONSTANTS.CABANG.STATUS_KAS_VIRTUAL
        },
        canSubmitMetodeKirim() {
            return this.newMetodeKirim.jenisPinjamanId != null && this.newMetodeKirim.deliveryChannel != null && this.newMetodeKirim.smDestination != null
        }
    },

    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        getJenisCabangLabel(cabang) {
            return cabang.isKcu ? "KCU" : "KCP"
        },

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleCabang = this.$axios.get(`cabang/${this.id}`).then(response => {
                this.cabang = response.data

                //Update Total Item di Halaman
                this.rows = this.cabang.staffs.length
                if (this.perPage > this.rows) this.perPage = this.rows
                this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
                this.initStatus = 1;

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.id)
                        this.cabangOption.push(element)
                })
            })

            let getDeliveryChannels = this.getDeliveryChannels()

            Promise.all([getSingleCabang, getCabang, getDeliveryChannels]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },
        

        //----------------- Fungsi Metode Pengiriman -----------------

        getDeliveryChannels(){
            return this.$axios.get("cabang/cabang-delivery-method", { params: { cabangId: this.id } }).then(response => {
                this.deliveryChannels = response.data
            })
            .catch(error => this.$helper.parseError(this, error))
        },

        openModalMetodeKirim(item = null){
            this.editingMetodeKirimId = item ? item.id : null
            this.isLoadingDeliveryChannelOptions = true

            Promise.all([
                this.$axios.get("cabang/list-delivery-channels"),
                this.$axios.get("cabang/sm-destination-selection"),
            ]).then(([channelRes, smRes]) => {
                this.deliveryChannelOptions = channelRes.data.filter(option => option.isActive)
                this.smDestinationOptions = smRes.data
                this.newMetodeKirim = {
                    jenisPinjamanId: item ? item.jenisPinjamanId : null,
                    deliveryChannel: item ? this.deliveryChannelOptions.find(option => option.id == item.deliveryChannelId) || null : null,
                    dropOffCabang: item && !item.isDropOffToOwnCabang ? this.cabangOption.find(option => option.id == item.dropOffDestinationCabangId) || null : null,
                    smDestination: item ? this.smDestinationOptions.find(option => option.id == item.smDestinationId) || null : null,
                }
                this.$bvModal.show('modal-tambah-metode-kirim')
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isLoadingDeliveryChannelOptions = false
            })
        },

        submitMetodeKirim(){
            this.isSubmittingMetodeKirim = true

            const body = {
                deliveryChannelId: this.newMetodeKirim.deliveryChannel.id,
                dropOffDestinationCabangId: this.newMetodeKirim.dropOffCabang ? this.newMetodeKirim.dropOffCabang.id : null,
                smDestinationId: this.newMetodeKirim.smDestination.id,
            }
            const request = this.editingMetodeKirimId
                ? this.$axios.post(`cabang/cabang-delivery-methods/${this.editingMetodeKirimId}`, body)
                : this.$axios.post("cabang/cabang-delivery-methods", { cabangId: this.id, jenisPinjamanId: this.newMetodeKirim.jenisPinjamanId, ...body })

            request.then(() => {
                this.$bvModal.hide('modal-tambah-metode-kirim')
                this.$helper.toastSucc(this, this.editingMetodeKirimId ? "Metode pengiriman berhasil diubah!" : "Metode pengiriman berhasil ditambahkan!")
                return this.getDeliveryChannels()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isSubmittingMetodeKirim = false
            })
        },

        //----------------- Fungsi Pagination -----------------

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        editCabang(){
            this.$router.push({
                path: `${this.$route.path}/edit`
            })
        },

        modalMutasi(){
            this.$bvModal.show("modal-mutasi")
        },
        confirmMutasi(){
            if(this.input.cabang == null ) {
                this.$helper.toastErr(this, "Mohon pilih Cabang terlebih dahulu!")
                return
            }
            this.$bvModal.show("modal-confirm-mutasi")
        },
        submitMutasi(){
            this.isSubmitting = true
            let payload = new FormData()
            payload.append("fromCabangId", this.id)
            payload.append("toCabangId", this.input.cabang.id)
            
            this.$helper.printPayload(payload)
            this.$axios.post("cabang/move-inventory", payload).then(response => { 

                this.$helper.toastSucc(this, "Cabang berhasil dimutasikan")
                this.$bvModal.hide("modal-confirm-mutasi")
                this.$bvModal.hide("modal-mutasi")
            })
                .catch(error => {
                this.$helper.parseError(this, error)
            })
                .finally(() => {
                this.isSubmitting = false
                this.input.cabang = null
            })
        },
    },

    created(){
        this.init()
    }
}
</script>
